// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3nDiu","signatureButtonsRight":"ModalSign_signatureButtonsRight__3XAY0"};